/* CES store: badge filtering.
   Works for the homepage "CES shop grid" section and for collection pages.
   A filter area is any element with data-ces-shop; inside it, data-ces-grid holds the
   product <li>s, chips carry data-ces-filter, data-ces-count shows "Showing n of N" and
   data-ces-none is the empty message. Badge legend tiles (data-ces-legend) filter the
   first shop area on the page and scroll to it. Everything is looked up on each click,
   so it keeps working after Shopify's filters or sorting reload the product grid. */
(function () {
  function itemsIn(scope) {
    var grid = scope.querySelector('[data-ces-grid]');
    if (!grid) return [];
    return Array.prototype.slice.call(grid.children).filter(function (li) { return li.querySelector('.ces-card'); });
  }

  function apply(scope, key) {
    var items = itemsIn(scope);
    var shown = 0;
    items.forEach(function (li) {
      var card = li.querySelector('.ces-card');
      var badges = ' ' + (card.getAttribute('data-badges') || '') + ' ';
      var ok = key === 'all' || badges.indexOf(' ' + key + ' ') !== -1;
      li.hidden = !ok;
      if (ok) shown++;
    });
    var count = scope.querySelector('[data-ces-count]');
    var none = scope.querySelector('[data-ces-none]');
    if (count) count.textContent = key === 'all' ? '' : 'Showing ' + shown + ' of ' + items.length;
    if (none) none.hidden = shown !== 0;
    scope.querySelectorAll('.ces-chip[data-ces-filter]').forEach(function (b) {
      var on = b.getAttribute('data-ces-filter') === key;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('.ces-legend__item[data-ces-filter]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-ces-filter') === key);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ces-filter]');
    if (!t) return;
    var fromLegend = !!t.closest('[data-ces-legend]');
    var scope = fromLegend ? document.querySelector('[data-ces-shop]') : t.closest('[data-ces-shop]');
    if (!scope) return; // legend with no grid on the page: let the link work
    e.preventDefault();
    apply(scope, t.getAttribute('data-ces-filter'));
    if (fromLegend) scope.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* CES round-up: "Add a gift for CES" buttons in the cart drawer and on the cart page. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ces-roundup-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-ces-roundup]');
    var err = box && box.querySelector('[data-ces-roundup-error]');
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = box && box.getAttribute('data-where') === 'drawer' && drawer && typeof drawer.renderContents === 'function';
    box && box.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    btn.setAttribute('aria-busy', 'true');
    var body = { items: [{ id: Number(btn.getAttribute('data-ces-roundup-add')), quantity: Number(btn.getAttribute('data-qty')) || 1 }] };
    if (inDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) {
        if (inDrawer && j.sections) { j.id = body.items[0].id; drawer.renderContents(j); }
        else window.location.reload();
      })
      .catch(function () {
        box && box.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
        btn.removeAttribute('aria-busy');
        if (err) err.hidden = false;
      });
  });
})();

/* "Show more products" on collection pages: loads the next page into the same grid. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ces-loadmore]');
    if (!btn) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.textContent;
    btn.textContent = 'Loading…';
    var url = new URL(btn.href, window.location.href);
    var sid = grid.getAttribute('data-id');
    if (sid) url.searchParams.set('section_id', sid);
    fetch(url.toString())
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        var first = null;
        items.forEach(function (li) { var n = document.importNode(li, true); n.classList.remove('scroll-trigger'); grid.appendChild(n); if (!first) first = n; });
        var next = doc.querySelector('[data-ces-loadmore]');
        var wrap = btn.closest('[data-ces-loadmore-wrap]');
        var count = wrap && wrap.querySelector('[data-ces-loadmore-count]');
        var shown = grid.querySelectorAll(':scope > li').length;
        var total = btn.getAttribute('data-total');
        if (count) count.textContent = 'Showing ' + shown + ' of ' + total;
        if (next) { btn.href = next.href; btn.textContent = label; btn.removeAttribute('aria-busy'); }
        else if (wrap) { if (count) count.textContent = 'Showing all ' + total; btn.remove(); }
        var link = first && first.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      })
      .catch(function () { window.location.href = btn.href; });
  });
})();

/* Category chip row: bring the current category into view. */
(function () {
  function center() {
    document.querySelectorAll('.ces-cats--chips .ces-cats__list').forEach(function (list) {
      var cur = list.querySelector('.is-current');
      if (cur) list.scrollLeft = cur.offsetLeft - (list.clientWidth - cur.offsetWidth) / 2;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', center); else center();
})();
